import React from "react"

import { AppCategoriesAutocomplete } from "@components"
import { useUserSettingsCategory, useUserSettingsCategoryValidator } from "../../../@hooks"
import { userSettingCategoryFormData } from "../../../@signals"


export default function UserSettingCategoryDrawerCategory() {
	const { handleChangeCategoryFormData } = useUserSettingsCategory()
	const { categoryError } = useUserSettingsCategoryValidator()

    return <AppCategoriesAutocomplete
		disableClearable
		multiple={false}
		placeholder="Select category"
		error={categoryError}
		value={userSettingCategoryFormData.value?.id_category || ''}
		onChange={e => handleChangeCategoryFormData(e.target.value, 'id_category')}
	/>
}